export default __webpack_public_path__ + "static/logo_white-400px-38f3589ef48d0b629876bd8c27858ecf.png";